async function downloadFromUrl(input, defaultFilename = "download") {
  // Helper to download a single file using a direct link
  function downloadSingle(url, filename) {
    const link = document.createElement("a");
    link.href = url;
    link.download = filename;
    link.target = "_blank"; // optional: opens in new tab in some cases
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }

  // If input is an array: download multiple
  if (Array.isArray(input)) {
    for (let i = 0; i < input.length; i++) {
      const { imageUrl } = input[i];
      const extension = imageUrl.split(".").pop().split("?")[0] || "jpg";
      downloadSingle(imageUrl, `${defaultFilename}_${i + 1}.${extension}`);
    }
  }
  // If input is a string: download one
  else if (typeof input === "string") {
    const extension = input.split(".").pop().split("?")[0] || "jpg";
    downloadSingle(input, `${defaultFilename}.${extension}`);
  } else {
    console.error("Invalid input to downloadFromUrl");
  }
}

export default downloadFromUrl;
